'use client';

import type { BreakPoint } from '@/components/ResponsiveOverylay';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { type Tenure, useTenureFilterStore } from './store/store';

export const TENURE_OPTIONS = [
  { name: 'Bostadsrätt', value: 'Bostadsrätt' },
  { name: 'Äganderätt', value: 'Äganderätt' },
  { name: 'Alla upplåtelseformer', value: null },
];

export const getTenureDescription = (tenure?: Tenure | null) => {
  return TENURE_OPTIONS.find((t) => t.value === tenure);
};

interface TenureSelectProps {
  includeDescription: boolean;
  breakPoint: BreakPoint['breakPoint'];
  fullWidth?: boolean;
}

export function TenureSelect({ includeDescription, breakPoint, fullWidth = false }: TenureSelectProps) {
  const { tenure, setTenure } = useTenureFilterStore();

  return (
    <>
      <div className={`${includeDescription ? 'block' : 'hidden'} ${breakPoint}:block ${breakPoint}:px-0`}>
        <p className='font-semibold'>Upplåtelseform</p>
        <p className='text-primary/50 mb-3 text-sm'>Välj den upplåtelseform du vill inkludera.</p>
      </div>
      <Select
        value={tenure as string}
        onValueChange={(value: Tenure) => setTenure({ tenure: value })}
      >
        <SelectTrigger
          className={`mt-0 ${fullWidth ? 'w-full' : 'w-47.25'} ${breakPoint}:w-full gap-2 bg-white whitespace-nowrap
            ${includeDescription ? 'font-normal' : 'font-display'}`}
        >
          <SelectValue>{getTenureDescription(tenure)?.name}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {TENURE_OPTIONS.map((tenureOption) => (
              <SelectItem
                key={tenureOption.name}
                value={tenureOption.value as string}
              >
                {tenureOption.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </>
  );
}
